import {Component, ElementRef, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {Config} from '../config';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';



@Component({
    selector: 'searchModule-component',
    template: require('../tools/searchModule.component.html'),
    styles: [require('../tools/searchModule.component.css')]
})
export class SearchModuleComponent{
    appSettings: Object = null;
    searchComponentOn:boolean = true;

    constructor(private elRef:ElementRef, private _mapService:MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService){

    }

    ngOnInit(){
        this._eventsService.searchToolShow$.subscribe(evt => {
            if(evt == false){
                setTimeout(() => {
                    this.searchComponentOn = evt;
                }, 1000);
            }
        });
    }

    selectFilterTool(ev:any){
        if(this.searchComponentOn == true){
            this._eventsService.searchToolShow(false);
            this.searchComponentOn = false;
        }else{
            this._eventsService.searchToolShow(true);
            this.searchComponentOn = true;
        }
    }
}


// WEBPACK FOOTER //
// ./app/tools/searchModule.component.ts